import React from 'react';

interface SlideNavigationProps {
  totalSlides: number;
  currentSlideIndex: number;
  onNavigate: (index: number) => void;
}

export const SlideNavigation: React.FC<SlideNavigationProps> = ({
  totalSlides,
  currentSlideIndex,
  onNavigate,
}) => {
  return (
    <div className="fixed right-6 top-1/2 -translate-y-1/2 z-40 flex flex-col items-center gap-3">
      {Array.from({ length: totalSlides }, (_, index) => (
        <button
          key={index}
          onClick={() => onNavigate(index)}
          className={`rounded-full transition-all ${
            index === currentSlideIndex
              ? 'w-3 h-3 bg-[#DFE4EA]'
              : 'w-2 h-2 bg-[rgba(223,228,234,0.3)] hover:bg-[rgba(223,228,234,0.5)]'
          }`}
          aria-label={`Go to slide ${index + 1}`}
        />
      ))}
    </div>
  );
};
